import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, TreeComponent } from '@xanadu/core';
import { Node, Category, Type, Branch } from '@xanadu/model';
import { NodeModel } from '@xanadu/model';
import { Observable } from 'rxjs';
import { TypeMenuBuilder } from '@xanadu/menu';

@Component({
    selector: 'app-type-tree',
    templateUrl: './type-tree.component.html',
    styleUrls: ['./type-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('type-tree')
export class TypeTreeComponent extends TreeComponent<Type | Category> {
    menuBuilder = inject(TypeMenuBuilder);

    protected override get nodeType(): string | undefined {
        return 'type';
    }

    onCategory() {
        const category = new Category(undefined);
        category.name = 'new category';
        this.addChild(category);
    }

    onType() {
        const type = new Type(undefined);
        type.name = 'new type';
        type.data = {};

        this.addChild(type);
    }

    onPaste() {
        this.paste();
    }

    protected replace(node: Node, branch: Branch): Observable<Type | Category> {
        return this.dataService.replace<Type | Category>(node as any, branch);
    }

    protected dropOk(dragModel: NodeModel, dropModel: NodeModel): boolean {
        const dragNode = dragModel.node;
        const dropNode = dropModel.node as Branch;

        return dragNode.fit(dropNode);
    }
}
